import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import DescriptionsTableBody from './TableBody';
import DescriptionTableHead from './TableHead';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

const ProductDescriptionTable = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table>
          <DescriptionTableHead />
          <TableBody>
            <DescriptionsTableBody />
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ProductDescriptionTable;
